(function() { window.GUID_3d3f8916_496c_46b7_b89d_669e15bfa06c = { getGuid: function() { return "3d3f8916-496c-46b7-b89d-669e15bfa06c"; } }; })();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class StackedBarChart extends Controls.ControlBase {
            get ControlId() {
                return this.controlId;
            }
            get $Control() {
                return $(`#${this.ControlId}`);
            }
            constructor(props) {
                super();
                this.datasets = [];
                this.datapoints = [];
                /**
                 * Each key is a string in the format "personaId:statFieldId"
                 */
                this.keys = new Set();
                this.personaIds = new Set();
                this.statFieldIds = new Set();
                this.paletteByPersonaId = new Map();
                this.displayNameByPersonaId = new Map();
                this.imageUrlByPersonaId = new Map();
                this.valueByKey = new Map();
                this.state = ChartState.Unready;
                this.orientation = "horizontal";
                this.textColorX = "rgba(255,255,255,0.7)";
                this.textColorY = "rgba(255,255,255,0.87)";
                this.barHeight = 40;
                this.barPadding = 0.2;
                this.chartInnerWidth = 0;
                this.chartInnerHeight = 0;
                this.chartMarginRight = 0;
                this.chartMarginTop = 8;
                this.chartMarginLeft = 0;
                this.chartMarginBottom = 0;
                this.resizeTimeout = null;
                this.controlId = props.controlId;
                this.id = props.id;
                this.datasets = props.datasets;
            }
            OnControlInstantiation(params) {
                this.controlId = params[0];
            }
            OnDispose() {
                CS.DOM.$win.off(`resize.${this.ControlId}-${this.id}`);
            }
            OnBindEvents() {
                CS.DOM.$win.offon(`resize.${this.ControlId}-${this.id}`, this.handleResize.bind(this));
            }
            handleResize() {
                return __awaiter(this, void 0, void 0, function* () {
                    if (this.resizeTimeout) {
                        clearTimeout(this.resizeTimeout);
                    }
                    this.resizeTimeout = setTimeout(() => __awaiter(this, void 0, void 0, function* () {
                        this.resizeTimeout = null;
                        yield this.reRender();
                    }), 250);
                });
            }
            unRender() {
                this.removeSVG();
            }
            removeSVG() {
                if (this.svg) {
                    this.svg.remove();
                }
            }
            reRender() {
                return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                    try {
                        this.rootElement.style.minHeight = `${this.rootElement.clientHeight}px`;
                        this.unRender();
                        this.setSeries();
                        this.render()
                            .then(() => {
                            this.rootElement.style.minHeight = "";
                            this.setLegend();
                            return resolve();
                        })
                            .catch((error) => {
                            console.error("Error while re-rendering CSRChart.", error);
                            return reject(error);
                        });
                    }
                    catch (error) {
                        console.error("Error while re-rendering CSRChart.", error);
                        return reject(error);
                    }
                }));
            }
            initialize() {
                return __awaiter(this, void 0, void 0, function* () {
                    try {
                        if (this.state !== ChartState.Unready) {
                            return;
                        }
                        this.state = ChartState.Initializing;
                        this.setDatapoints();
                        this.setValueByKey();
                        this.setFontSizes();
                        this.setPersonaIds();
                        this.setDisplayNameByPersonaId();
                        this.setImageUrlByPersonaId();
                        this.setStatFieldIds();
                        this.setKeys();
                        this.setPaletteByPersonaId();
                        this.setHTML();
                        this.setSeries();
                        this.setLegend();
                        yield this.render();
                        setTimeout(() => __awaiter(this, void 0, void 0, function* () {
                            yield this.handleResize();
                        }), 100);
                    }
                    catch (error) {
                        console.error("Error while initializing chart", error);
                        this.state = ChartState.Error;
                    }
                });
            }
            setDatapoints() {
                this.datapoints = [];
                this.datasets.forEach((dataset) => {
                    dataset.Datapoints.forEach((datapoint) => {
                        this.datapoints.push(Object.assign(Object.assign({}, datapoint), { Key: `${datapoint.PersonaId}:${datapoint.StatFieldId}`, Id: datapoint.StatFieldId }));
                    });
                });
            }
            setValueByKey() {
                this.datapoints.forEach((datapoint) => {
                    this.valueByKey.set(`${datapoint.PersonaId}:${datapoint.StatFieldId}`, datapoint.Value);
                });
            }
            setFontSizes() {
                this.fontSizeX = 12;
                this.fontSizeY = 14;
            }
            setPersonaIds() {
                this.datasets.forEach((dataset) => {
                    dataset.Datapoints.forEach((datapoint) => {
                        this.personaIds.add(datapoint.PersonaId);
                    });
                });
                this.personaIds = new Set(Array.from(this.personaIds).sort((a, b) => {
                    var _a, _b, _c, _d;
                    const aValue = parseFloat((_b = (_a = this.valueByKey.get(`${a}:Wins`)) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : "0");
                    const bValue = parseFloat((_d = (_c = this.valueByKey.get(`${b}:Wins`)) === null || _c === void 0 ? void 0 : _c.toString()) !== null && _d !== void 0 ? _d : "0");
                    return bValue - aValue;
                }));
            }
            setDisplayNameByPersonaId() {
                this.datasets.forEach((dataset) => {
                    this.displayNameByPersonaId.set(dataset.PersonaId, dataset.DisplayName);
                });
            }
            setImageUrlByPersonaId() {
                this.datasets.forEach((dataset) => {
                    this.imageUrlByPersonaId.set(dataset.PersonaId, dataset.ImageUrl);
                });
            }
            setStatFieldIds() {
                this.datasets.forEach((dataset) => {
                    dataset.Datapoints.forEach((datapoint) => {
                        this.statFieldIds.add(datapoint.StatFieldId);
                    });
                });
            }
            setKeys() {
                this.datasets.forEach((dataset) => {
                    dataset.Datapoints.forEach((datapoint) => {
                        this.keys.add(`${datapoint.PersonaId}:${datapoint.StatFieldId}`);
                    });
                });
            }
            setPaletteByPersonaId() {
                const colors = CS.Helper.DataVisualizationHelper.getColors(this.personaIds.size);
                let index = 0;
                this.personaIds.forEach((personaId) => {
                    const color = colors[index];
                    const palette = {
                        color: new Map([
                            ["Wins", color],
                            ["Losses", `${color}1A`],
                        ]),
                    };
                    this.paletteByPersonaId.set(personaId, palette);
                    index++;
                    if (index >= colors.length) {
                        index = 0;
                    }
                });
            }
            setHTML() {
                this.rootElement = document.getElementById(this.id);
                if (!this.rootElement)
                    throw new Error("Root element not found");
                const chartContainerMarkup = `
    <div id="${this.id}-stacked-bar-chart-container" class="stacked-bar-chart-container">
      <div id="${this.id}-stacked-bar-chart" class="stacked-bar-chart"></div>
    </div>`;
                const legendMarkup = `
    <div class="stacked-bar-chart__legend">
    </div>`;
                this.rootElement.innerHTML = `
        ${legendMarkup}
        ${chartContainerMarkup}`;
                const _chartContainerElement = document.getElementById(`${this.id}-stacked-bar-chart-container`);
                if (!_chartContainerElement)
                    throw new Error("Chart container element not found");
                this.chartContainerElement = _chartContainerElement;
            }
            setSeries() {
                this.series = d3
                    .stack()
                    .keys(d3.union(this.datapoints.map((d) => d.StatFieldId)))
                    .value(([, D], key) => D.get(key).Value)(d3.index(this.datapoints, (d) => d.PersonaId, (d) => d.StatFieldId));
            }
            setLegend() {
                const legendElement = this.rootElement.querySelector(".stacked-bar-chart__legend");
                if (!legendElement)
                    throw new Error("Legend element not found");
                legendElement.innerHTML = "";
                Array.from(this.statFieldIds).forEach((statFieldId) => {
                    if (statFieldId === "Losses")
                        return;
                    const legendRow = document.createElement("div");
                    legendRow.classList.add("stacked-bar-chart__legend__row");
                    Array.from(this.personaIds).forEach((personaId) => {
                        var _a, _b, _c;
                        const color = (_a = this.paletteByPersonaId
                            .get(personaId)) === null || _a === void 0 ? void 0 : _a.color.get(statFieldId);
                        if (!color)
                            return;
                        let value = (_b = this.valueByKey.get(`${personaId}:${statFieldId}`)) !== null && _b !== void 0 ? _b : "N/A";
                        if (value !== "N/A") {
                            value = value + "%";
                        }
                        const legendItem = document.createElement("div");
                        legendItem.dataset.value = value;
                        legendItem.classList.add("stacked-bar-chart__legend__item");
                        if (value === "N/A") {
                            legendItem.classList.add("stacked-bar-chart__legend__item--not-available");
                        }
                        const label = (_c = this.displayNameByPersonaId.get(personaId)) !== null && _c !== void 0 ? _c : "-";
                        legendItem.innerHTML = `
              <div class="stacked-bar-chart__legend__item__color" style="background-color: ${color};"></div>
              <div class="stacked-bar-chart__legend__item__label">${label}</div>
              <div class="stacked-bar-chart__legend__item__value">
                ${value}
              </div>
            `;
                        legendRow.appendChild(legendItem);
                    });
                    legendElement.appendChild(legendRow);
                });
            }
            render() {
                return new Promise((resolve, reject) => __awaiter(this, void 0, void 0, function* () {
                    try {
                        yield this.setChartDimensions();
                        this.setScales();
                        this.setSVG();
                        this.drawBars();
                        this.drawAxes();
                        this.appendSVGNode();
                        return resolve();
                    }
                    catch (error) {
                        console.error("Error while rendering Chart.", error);
                        return reject(error);
                    }
                }));
            }
            setChartDimensions() {
                return new Promise((resolve, reject) => {
                    try {
                        requestAnimationFrame(() => {
                            const containeRect = this.chartContainerElement.getBoundingClientRect();
                            this.chartInnerWidth =
                                containeRect.width - this.chartMarginLeft - this.chartMarginRight;
                            this.chartInnerHeight =
                                this.series[0].length * this.barHeight +
                                    this.chartMarginTop +
                                    this.chartMarginBottom;
                            return resolve();
                        });
                    }
                    catch (error) {
                        console.error("Error while setting chart dimensions.", error);
                        return reject(error);
                    }
                });
            }
            setScales() {
                this.xScale = d3
                    .scaleLinear()
                    .domain([0, d3.max(this.series, (d) => d3.max(d, (d) => d[1])) || 0])
                    .range([
                    this.chartMarginLeft,
                    this.chartInnerWidth - this.chartMarginRight,
                ]);
                this.yScale = d3
                    .scaleBand()
                    .domain(d3.groupSort(this.datapoints, (D) => -d3.sum(D, (d) => {
                    const isWins = d.StatFieldId === "Wins";
                    return isWins ? d.Value : -d.Value;
                }), (d) => d.PersonaId))
                    .range([
                    this.chartMarginTop,
                    this.chartInnerHeight - this.chartMarginBottom,
                ])
                    .padding(this.barPadding);
            }
            setSVG() {
                this.svg = d3
                    .create("svg")
                    .attr("viewBox", [0, 0, this.chartInnerWidth, this.chartInnerHeight])
                    .attr("width", this.chartInnerWidth)
                    .attr("height", this.chartInnerHeight)
                    .attr("class", "stacked-bar-chart__svg")
                    .attr("style", "max-width: 100%; height: auto; height: intrinsic;")
                    .style("-webkit-tap-highlight-color", "transparent")
                    .style("overflow", "visible");
            }
            drawAxes() {
                this.svg
                    .append("g")
                    .attr("class", "stacked-bar-chart__x-axis")
                    .attr("transform", `translate(0, ${this.chartMarginTop})`)
                    .call(d3
                    .axisTop(this.xScale)
                    .ticks(this.chartInnerWidth / 100, "s")
                    .tickFormat((d) => d.toString() + "%"))
                    .selectAll("text")
                    .attr("font-size", this.fontSizeX)
                    .attr("fill", this.textColorX);
                this.svg
                    .append("g")
                    .attr("class", "stacked-bar-chart__y-axis")
                    .attr("transform", `translate(${this.chartMarginLeft}, 0)`)
                    .call(d3
                    .axisLeft(this.yScale)
                    .tickSizeOuter(0)
                    .tickFormat(() => ""))
                    .call((g) => g.selectAll(".tick line").remove())
                    .selectAll("text")
                    .attr("font-size", this.fontSizeY)
                    .attr("fill", this.textColorY);
            }
            drawBars() {
                this.svg
                    .append("g")
                    .selectAll()
                    .data(this.series)
                    .join("g")
                    .selectAll("rect")
                    .data((D) => D.map((d) => ((d.key = D.key), d)))
                    .join("rect")
                    .attr("class", "stacked-bar-chart__bar")
                    .attr("x", (d) => this.xScale(d[0]))
                    .attr("y", (d) => this.yScale(d.data[0]) || 0)
                    .attr("height", this.yScale.bandwidth())
                    .attr("width", (d) => this.xScale(d[1]) - this.xScale(d[0]))
                    .attr("fill", (d) => {
                    var _a, _b;
                    const statFieldId = d.key;
                    const personaId = d.data[0];
                    const color = (_b = (_a = this.paletteByPersonaId.get(personaId)) === null || _a === void 0 ? void 0 : _a.color.get(statFieldId)) !== null && _b !== void 0 ? _b : "rgba(255,255,255,0.1)";
                    return color;
                });
            }
            appendSVGNode() {
                const svgNode = this.svg.node();
                if (!(svgNode instanceof SVGSVGElement)) {
                    throw new Error("SVG node not found.");
                }
                this.chartContainerElement.appendChild(svgNode);
            }
        }
        Controls.StackedBarChart = StackedBarChart;
        let ChartState;
        (function (ChartState) {
            ChartState["Initializing"] = "initializing";
            ChartState["Unready"] = "unready";
            ChartState["Ready"] = "ready";
            ChartState["Running"] = "running";
            ChartState["Stopping"] = "stopping";
            ChartState["Stopped"] = "stopped";
            ChartState["Error"] = "error";
            ChartState["Finished"] = "finished";
            ChartState["Destroying"] = "destroying";
            ChartState["Loading"] = "loading";
        })(ChartState || (ChartState = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=StackedBarChart.js.map
